import React from 'react';

import { Icon } from '@chakra-ui/react';

export const CacheBehaviourIcon = props => (
  <Icon viewBox="0 0 32 32" color="inherit" h="full" w="full" {...props}>
    <polygon
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      points="25,16 19,16 26,3 14,3 7,16 13,16 7,29 "
    />
  </Icon>
);
